import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import BookmarkButton from "@/components/feature/BookmarkButton";

export default function TrendingRank() {
  const ranked = [...topics].sort((a, b) => b.heat - a.heat).slice(0, 6);
  const maxHeat = ranked[0]?.heat ?? 1;

  return (
    <section id="ranking" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
              <i className="ri-fire-line"></i>
              Weekly Ranking
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              本周热榜
            </h2>
            <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">
              热度综合阅读、收藏、转发与讨论量得出，反映话题近期的受关注程度。看到感兴趣的直接收藏，
              之后在话题库里随时回看。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-accent-100 text-accent-900 text-xs">
                <i className="ri-refresh-line"></i>
                每日 09:00 更新
              </span>
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-secondary-100 text-secondary-900 text-xs">
                <i className="ri-bookmark-3-line"></i>
                支持一键收藏
              </span>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="space-y-3">
              {ranked.map((topic, i) => {
                const width = Math.round((topic.heat / maxHeat) * 100);
                return (
                  <li key={topic.id}>
                    <div className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
                      <span
                        className={`w-9 h-9 shrink-0 flex items-center justify-center rounded-md font-heading text-lg font-bold ${
                          i < 3
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        {i + 1}
                      </span>

                      <div className="min-w-0 flex-1">
                        <Link
                          to={`/topics?category=${encodeURIComponent(topic.category)}`}
                          className="block font-heading text-sm md:text-base font-semibold text-foreground-950 hover:text-primary-700 transition-colors cursor-pointer truncate"
                        >
                          {topic.title}
                        </Link>
                        <div className="mt-2 flex items-center gap-3">
                          <div className="h-1.5 flex-1 max-w-[220px] rounded-full bg-background-200 overflow-hidden">
                            <div
                              className="h-full rounded-full bg-primary-500"
                              style={{ width: `${width}%` }}
                            ></div>
                          </div>
                          <span className="text-xs text-foreground-500 whitespace-nowrap">
                            {topic.heat.toLocaleString()} 热度
                          </span>
                        </div>
                      </div>

                      <span className="hidden md:inline-flex px-2.5 py-1 rounded-md bg-secondary-50 text-secondary-900 text-[11px] whitespace-nowrap">
                        {topic.category}
                      </span>
                      <BookmarkButton id={topic.id} tone="icon" />
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}